import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import { OperadorService } from '../services/operador.service';

@Component({
  selector: 'app-loginform',
  templateUrl: './loginform.component.html',
  styleUrls: ['./loginform.component.scss'],
})
export class LoginformComponent implements OnInit {
  public faEye = faEye;
  public faEyeSlash = faEyeSlash;

  public hide = true;

  public loginFrm: FormGroup;
  public usuario: FormControl;
  public senha: FormControl;

  public ckManter: FormControl;

  public goTo: string = null;
  public invalidAuth: boolean = false;

  constructor(
    private _operadorService: OperadorService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((params) => {
      this.goTo = params['goTo'];
    });
  }

  ngOnInit(): void {
    this.createFormControls();
    this.createForm();
  }

  createFormControls() {
    this.usuario = new FormControl('', [Validators.required]);
    this.senha = new FormControl('', [
      Validators.required,
      Validators.minLength(6),
    ]);
    this.ckManter = new FormControl(false);
  }

  createForm() {
    this.loginFrm = new FormGroup({
      usuario: this.usuario,
      senha: this.senha,
      ckManter: this.ckManter,
    });
  }

  toogleViewPassChange() {
    this.hide = !this.hide;
  }

  ckManterChange() {
    this.ckManter = new FormControl(!this.ckManter.value);
  }

  onSubmit() {
    if (this.loginFrm.valid) {
      this._operadorService
        .login(this.usuario.value, this.senha.value)
        .subscribe(
          (data) => {
            if (data['access_token']) {
              this._operadorService.setOperadorLoggedIn(
                data,
                this.ckManter.value
              );

              this._operadorService.profile().subscribe((data) => {
                let op = this._operadorService.getOperador();

                let store = op.estabelecimento;

                if (store['periodo_teste'] != null) {
                  this.router.navigate(['/app/bem-vindo']);
                } else {
                  if (this.goTo !== null && this.goTo !== undefined) {
                    this.router.navigate([this.goTo]);
                  } else {
                    this.router.navigate(['app']);
                  }
                }
              });
            } else {
              this.invalidAuth = true;
            }
          },
          (error) => {
            this.invalidAuth = true;
          }
        );
      return false;
    }
  }
}
